import React from 'react'
import LegalLayout from '../../components/LegalLayout'

/** 위치기반서비스 이용약관. URL: /location-terms */
const LocationTermsPage: React.FC = () => {
  return (
    <LegalLayout>
      <h1>위치기반서비스 이용약관</h1>

      <h2>제1조 (목적)</h2>
      <p>
        본 약관은 TASTEE(이하 "회사")가 제공하는 위치기반서비스(이하 "서비스")와
        관련하여 회사와 개인위치정보주체 간의 권리, 의무 및 책임사항 등 기타 필요한
        사항을 규정함을 목적으로 합니다.
      </p>

      <h2>제2조 (약관의 적용 및 변경)</h2>
      <ul>
        <li>
          본 약관은 서비스를 이용하고자 하는 개인위치정보주체가 동의하고 회사가 정한
          절차에 따라 서비스 이용자로 등록한 때부터 효력이 발생합니다.
        </li>
        <li>
          본 약관에 명시되지 않은 사항은 「위치정보의 보호 및 이용 등에 관한
          법률」(이하 "위치정보법"), 「개인정보 보호법」 등 관계 법령 및 회사의
          개인정보처리방침, 서비스 이용약관에 따릅니다.
        </li>
        <li>
          회사는 관련 법령을 위반하지 않는 범위 내에서 본 약관을 개정할 수 있으며,
          개정 시 적용일자 및 개정 사유를 명시하여 적용일 7일 전(이용자에게 불리한
          변경의 경우 30일 전)부터 서비스 내 공지 후 시행합니다.
        </li>
      </ul>

      <h2>제3조 (서비스 내용 및 요금)</h2>
      <p>
        회사는 이용자가 위치 권한을 허용한 경우, 이동성 있는 기기(스마트폰 등)의 GPS
        정보를 직접 수집하여 다음과 같은 서비스를 제공합니다.
      </p>
      <table>
        <thead>
          <tr>
            <th scope="col">서비스 종류</th>
            <th scope="col">설명</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>위치 기반 장소 검색</td>
            <td>
              이용자의 현재 위치를 기준으로 음식점 등 장소 검색 결과를 가까운 순으로
              제공
            </td>
          </tr>
          <tr>
            <td>주변 기록 기반 추천</td>
            <td>
              이용자의 현재 위치를 반영하여 추천 피드의 기록을 정렬·제공
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        서비스 이용요금은 무료입니다. 단, 이동통신망 이용에 따른 데이터 요금은
        별도이며, 이용자가 가입한 통신사의 정책에 따릅니다.
      </p>
      <p>
        회사는 개인위치정보를 해당 요청의 처리를 위해 일회성 또는 임시로 이용한 후
        지체 없이 파기하며, 개인위치정보를 서버에 저장하지 않습니다.
      </p>

      <h2>제4조 (개인위치정보주체의 권리)</h2>
      <ul>
        <li>
          개인위치정보주체는 회사에 대해 다음 각 호의 권리를 행사할 수 있습니다.
          <ul>
            <li>
              개인위치정보의 수집·이용에 대한 동의 범위를 지정하거나 일부 동의를
              유보할 수 있습니다.
            </li>
            <li>
              언제든지 동의의 전부 또는 일부를 철회할 수 있으며, 이 경우 회사는 철회된
              범위 내에서 수집된 개인위치정보 및 위치정보 이용·제공 사실 확인자료를
              지체 없이 파기합니다.
            </li>
            <li>
              개인위치정보의 수집·이용의 일시적인 중지를 요구할 수 있습니다. 회사는 이
              요구를 거절하지 않으며, 이를 위한 기술적 수단(기기 내 위치 권한 설정
              등)을 제공합니다.
            </li>
            <li>
              회사에 대해 다음 사항의 열람 또는 고지를 요구할 수 있으며, 오류가 있는
              경우 정정을 요구할 수 있습니다. 회사는 정당한 사유 없이 이를 거절할 수
              없습니다.
              <ul>
                <li>
                  개인위치정보주체에 대한 위치정보 수집·이용·제공 사실 확인자료
                </li>
                <li>
                  개인위치정보가 위치정보법 또는 다른 법령에 따라 제3자에게 제공된
                  경우, 그 제공 목적, 시기 및 수신자 정보
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          개인위치정보주체는 위 권리를 기기 내 위치 권한 설정 또는 제10조의
          위치정보관리책임자에 대한 요청을 통해 행사할 수 있으며, 회사는 본인 여부를
          확인한 후 지체 없이 조치합니다.
        </li>
      </ul>

      <h2>제5조 (만 14세 미만 아동의 개인위치정보)</h2>
      <p>
        회사는 만 14세 미만 아동의 개인위치정보를 수집·이용·제공하지 않습니다. 만 14세
        미만 아동이 서비스를 이용한 사실이 확인되는 경우, 회사는 해당 계정 및 수집된
        정보를 지체 없이 삭제합니다.
      </p>

      <h2>제6조 (8세 이하 아동 등의 보호의무자 권리)</h2>
      <ul>
        <li>
          회사는 다음 각 호에 해당하는 자(이하 "8세 이하의 아동 등")의 보호의무자가 8세
          이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 수집·이용에
          동의하는 경우, 본인의 동의가 있는 것으로 봅니다.
          <ul>
            <li>8세 이하의 아동</li>
            <li>피성년후견인</li>
            <li>
              「장애인복지법」 제2조 제2항 제2호에 따른 정신적 장애를 가진 사람으로서
              「장애인고용촉진 및 직업재활법」 제2조 제2호에 따른 중증장애인에 해당하는
              사람(「장애인복지법」 제32조에 따라 장애인 등록을 한 사람에 한함)
            </li>
          </ul>
        </li>
        <li>
          보호의무자는 회사가 정한 방식에 따라 보호의무자임을 증명하는 서면을 첨부하여
          동의서를 제출하여야 합니다.
        </li>
        <li>
          보호의무자가 동의한 경우, 개인위치정보주체의 권리와 동일한 권리를 행사할 수
          있습니다.
        </li>
      </ul>

      <h2>제7조 (위치정보 이용·제공 사실 확인자료 보유)</h2>
      <p>
        회사는 위치정보법 제16조 제2항에 따라 위치정보의 수집·이용·제공 사실에 대한
        확인자료를 위치정보시스템에 자동으로 기록·보존하며, 해당 자료는 6개월간 보관 후
        파기합니다.
      </p>

      <h2>제8조 (서비스 변경 및 중지)</h2>
      <ul>
        <li>
          회사는 법령, 정책, 기술적 사유 등으로 인해 서비스의 전부 또는 일부를
          변경하거나 중지할 수 있습니다.
        </li>
        <li>
          이 경우 회사는 사전에 공지하며, 불가피한 경우 사후에 통지할 수 있습니다.
        </li>
      </ul>

      <h2>제9조 (개인위치정보의 제3자 제공)</h2>
      <ul>
        <li>
          회사는 개인위치정보주체의 동의 없이 개인위치정보를 제3자에게 제공하지 않으며,
          현재 개인위치정보를 이용자가 지정하는 제3자에게 제공하는 서비스를 제공하지
          않습니다.
        </li>
        <li>
          회사가 향후 개인위치정보를 개인위치정보주체가 지정하는 제3자에게 제공하는
          서비스를 제공하는 경우, 제공받는 자, 제공 일시 및 제공 목적을 개인위치정보를
          수집한 통신단말장치로 매회 즉시 통보하며, 별도의 동의를 받습니다.
        </li>
        <li>
          제2항에도 불구하고 다음 각 호의 경우에는 사전에 지정한 기기 또는 전자우편으로
          통보할 수 있습니다.
          <ul>
            <li>문자·음성 수신 기능이 없는 단말기를 사용하는 경우</li>
            <li>이용자가 온라인 게시 또는 전자우편을 통한 통보를 요청한 경우</li>
          </ul>
        </li>
      </ul>

      <h2>제10조 (위치정보관리책임자 및 사업자 정보)</h2>
      <p>
        회사는 위치정보를 안전하게 관리하고 관련 민원을 책임지고 처리할 수 있는
        위치정보관리책임자를 다음과 같이 지정합니다.
      </p>
      <table>
        <thead>
          <tr>
            <th scope="col">구분</th>
            <th scope="col">내용</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">상호</th>
            <td>(주)미디어인터랙티브</td>
          </tr>
          <tr>
            <th scope="row">책임자</th>
            <td>김경민 (대표)</td>
          </tr>
          <tr>
            <th scope="row">주소</th>
            <td>경기도 하남시 미사대로 520, CA동 1031호</td>
          </tr>
          <tr>
            <th scope="row">연락처</th>
            <td>admin@tastee.kr</td>
          </tr>
        </tbody>
      </table>

      <h2>제11조 (손해배상)</h2>
      <p>
        개인위치정보주체는 회사가 위치정보법 제15조 내지 제26조를 위반한 행위로 손해를
        입은 경우 회사에 손해배상을 청구할 수 있으며, 회사는 고의 또는 과실이 없음을
        입증하지 못하는 한 책임을 부담합니다.
      </p>

      <h2>제12조 (면책)</h2>
      <ul>
        <li>
          회사는 다음 각 호의 사유로 서비스를 제공할 수 없는 경우, 이로 인하여
          이용자에게 발생한 손해에 대해 책임을 부담하지 않습니다.
          <ul>
            <li>천재지변 또는 이에 준하는 불가항력의 상태가 있는 경우</li>
            <li>
              서비스 제공을 위하여 회사와 제휴계약을 체결한 제3자의 고의적인 서비스
              방해가 있는 경우
            </li>
            <li>이용자의 귀책사유로 서비스 이용에 장애가 있는 경우</li>
            <li>그 밖에 회사의 고의·과실이 없는 사유로 인한 경우</li>
          </ul>
        </li>
        <li>
          회사는 서비스에 게재된 정보, 자료, 사실의 신뢰도, 정확성 등에 대해 보증하지
          않으며, 회사의 고의 또는 과실 없이 이로 인해 발생한 이용자의 손해에 대해
          책임을 부담하지 않습니다.
        </li>
      </ul>

      <h2>제13조 (규정의 준용)</h2>
      <ul>
        <li>본 약관은 대한민국 법령에 의하여 규정되고 이행됩니다.</li>
        <li>본 약관에 규정되지 않은 사항에 대해서는 관계 법령 및 상관습에 따릅니다.</li>
      </ul>

      <h2>제14조 (분쟁 해결 및 조정)</h2>
      <ul>
        <li>
          회사 또는 개인위치정보주체는 위치정보와 관련된 분쟁이 협의로 해결되지 않는
          경우, 방송미디어통신위원회에 재정을 신청할 수 있습니다.
        </li>
        <li>
          회사 또는 개인위치정보주체는 위치정보와 관련된 분쟁이 협의로 해결되지 않는
          경우, 「개인정보 보호법」에 따라 개인정보분쟁조정위원회에 조정을 신청할 수
          있습니다.
        </li>
      </ul>

      <h2>부칙</h2>
      <p>
        <strong>본 약관은 2026년 7월 28일부터 시행합니다.</strong>
      </p>
    </LegalLayout>
  )
}

export default LocationTermsPage
